/* eslint-disable @nx/enforce-module-boundaries */
import { Component, ElementRef, Inject, ViewChild, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  Validators,
  NonNullableFormBuilder,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { LoaderIndicatorDirective, LoaderService, NotificationService } from '@t-llevo/common-ui';
import { finalize } from 'rxjs';
import { VersionControlDataService } from '../../services/version-control-data/version-control-data.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { DialogHeaderComponent } from 'admin-drivers/src/app/common/dialog/components/dialog-header/dialog-header.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Version } from 'admin-drivers/src/app/common/models/Version';
import { VersionControlService } from 'admin-drivers/src/app/api/services/version-control.service';

@Component({
  selector: 't-llevo-version-control-edit',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    DialogHeaderComponent,
    MatCheckboxModule,
    LoaderIndicatorDirective
  ],
  providers: [LoaderService],
  templateUrl: './version-control-edit.component.html',
  styles: `
  @import '../../../utils/styles/formGroup.scss';
  @import '../../../utils/styles/baseDialog.scss';
  `,
})
export class VersionControlEditComponent {
  private loaderSrv = inject(LoaderService);
  private notifSrv = inject(NotificationService);
  private versionSrv = inject(VersionControlService);
  private versionDataSrv = inject(VersionControlDataService);


  loading = toSignal(this.loaderSrv.loaderState$);
  @ViewChild('firstInput') elementRef!: ElementRef<HTMLInputElement>

  frm = this._fb.group({
    versionCode: ['', Validators.required],
    versionName: ['', Validators.required],
    urlDownload: ['', [Validators.required, Validators.pattern(/^(http(s):\/\/.)[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)$/)]],
    required: [false, [Validators.required]],
    description: [''],
  });

  constructor(
    public dialogRef: MatDialogRef<VersionControlEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Version,
    private _fb: NonNullableFormBuilder
  ) {
    this.dialogRef.afterOpened().subscribe(() => {
      this.assignData();
      setTimeout(() => {
        this.elementRef.nativeElement.focus()
      }, 50)
    });
  }

  private assignData() {
    this.versionCode.setValue(this.data.versionCode);
    this.versionName.setValue(this.data.versionName);
    this.urlDownload.setValue(this.data.urlDownload);
    this.required.setValue(this.data.required);
    this.description.setValue(this.data.description);
  }

  onSubmit() {
    this.loaderSrv.show();

    const params = {
      ...this.frm.getRawValue(),
      packageName: this.versionDataSrv.getAppConfig().packageName,
    }

    this.versionSrv
      .updateVersionById(params, this.data.id)
      .pipe(finalize(() => this.loaderSrv.hide()))
      .subscribe({
        next: () => {
          this.notifSrv.dispatch('Versión editada', 'success');
          this.dialogRef.close(true);
        },
        error: (err: HttpErrorResponse) => {
          this.notifSrv.dispatch(err.error.message, 'error');
        },
      });
  }

  get versionCode() {
    return this.frm.controls['versionCode'];
  }

  get versionName() {
    return this.frm.controls['versionName'];
  }

  get urlDownload() {
    return this.frm.controls['urlDownload'];
  }

  get required() {
    return this.frm.controls['required'];
  }

  get description() {
    return this.frm.controls['description'];
  }
}
